import querystring from 'querystring';
const trackingCriteria = ['fuelTypeGroup', 'minPrice', 'maxPrice', 'startYear', 'endYear', 'searchRadius', 'zip', 'listingTypes', 'vehicleStyleCodes', 'maxMileage', 'makeCodeList', 'modelCodeList', 'seriesCodeList', 'trimCodeList', 'seriesTrimCodeList', 'interiorColorsSimple', 'extColorsSimple', 'listingType', 'vehicleStyleCode', 'mileage', 'makeCode', 'modelCode', 'seriesCode', 'trimCode', 'seriesTrimCode', 'intColorSimple', 'extColorSimple'];

// see reaxl-analytics readme section about Pixall API to determine what the label should be
const trackingCriteriaLabels = {
  fuelTypeGroup: 'searchFacetFuelTypes',
  minPrice: 'searchFacetMinPrice',
  maxPrice: 'searchFacetMaxPrice',
  startYear: 'searchFacetMinYear',
  endYear: 'searchFacetMaxYear',
  searchRadius: 'searchFacetDistance',
  zip: 'searchFacetZipCode',
  // CS
  listingTypes: 'searchFacetVehicleTypes',
  vehicleStyleCodes: 'searchFacetBodyStyles',
  maxMileage: 'searchFacetMileage',
  makeCodeList: 'searchFacetMake',
  modelCodeList: 'searchFacetModel',
  seriesCodeList: 'searchFacetSeries',
  trimCodeList: 'searchFacetTrim',
  // there are two possible query parameters that could be a searchFaceTrim
  seriesTrimCodeList: 'searchFacetTrim',
  interiorColorsSimple: 'searchFacetInteriorColors',
  extColorsSimple: 'searchFacetExteriorColors',
  // LSC
  listingType: 'searchFacetVehicleTypes',
  vehicleStyleCode: 'searchFacetBodyStyles',
  mileage: 'searchFacetMileage',
  makeCode: 'searchFacetMake',
  modelCode: 'searchFacetModel',
  seriesCode: 'searchFacetSeries',
  trimCode: 'searchFacetTrim',
  seriesTrimCode: 'searchFacetTrim',
  intColorSimple: 'searchFacetInteriorColors',
  extColorSimple: 'searchFacetExteriorColors'
};

/**
 * if filterValues are available use those first, since redux values should always be available on SRP's; convert all
 * search facet values toString() so that multiple selections are only assigned to one search facet
 * if no filterValues are sent use query string parameters
 * @param filterValues
 * @returns {{}}
 */
function getSearchFacetVariables(filterValues) {
  let params = null;
  if (filterValues && JSON.stringify(filterValues) !== '{}') {
    params = filterValues;
  } else if (window.location.search.slice(1)) {
    params = querystring.parse(window.location.search.slice(1)) || {};
  }
  if (params) {
    return trackingCriteria.reduce((acc, key) => {
      const paramKey = trackingCriteriaLabels[key];
      if (paramKey && !acc[paramKey]) {
        acc[paramKey] = params[key] ? params[key].toString() : undefined;
      }
      return acc;
    }, {});
  }
  return {};
}
export default {
  getSearchFacetVariables
};